import React from 'react';
import MainMenuItem from '@/Shared/MainMenuItem';
import { faPlus, faClipboardList, faExternalLinkAlt, faCaretDown, faCaretUp, faCog, faCogs } from '@fortawesome/free-solid-svg-icons'
import { Accordion, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useProps } from '@/Shared/FuncComp';

const AccordionMenu = ({children, ...props}) => {
	const [activeKey, setActiveKey] = React.useState(null);
	if (!props.eventKey) props.eventKey = 'menu-acc-0';
	const titleIcon = props.icon ? <FontAwesomeIcon icon={props.icon} {...props.iconProps} /> : null;
	return <Accordion activeKey={activeKey} onSelect={key=>setActiveKey(key)}>
		<Card>
			<Accordion.Toggle as={Card.Header} eventKey={props.eventKey}>
				<div className="py-2">{titleIcon} {props.title}</div> <div className={"icon"+(activeKey?' pt-1':'')}>
					<FontAwesomeIcon icon={activeKey ? faCaretUp : faCaretDown} />
				</div>
			</Accordion.Toggle>
			<Accordion.Collapse eventKey={props.eventKey}>
				<Card.Body>
					{children}
				</Card.Body>
			</Accordion.Collapse>
		</Card>
	</Accordion>
}

export default ({ className }) => {
	const {auth} = useProps();
	className = 'main-menu'+(className?' '+className:'');
	return (
		<div className={className}>
			<MainMenuItem text="Dashboard" exact link="dashboard" icon="dashboard" />
			<hr />
			<MainMenuItem text="Cotizaciones" link="cotizaciones.index" icon={faClipboardList} />
			<hr />
			<MainMenuItem text="Categorías" exact link="categorias.index" icon={faPlus} />
			<MainMenuItem text="Subcategorías" exact link="subcategorias.index" icon={faPlus} />
			<MainMenuItem text="Productos" link="productos.index" icon={faPlus} />
			<MainMenuItem text="Marcas" link="marcas.index" icon={faPlus} />
			<hr />
			{/* <MainMenuItem text="Redirecciones" link="config.redirects" icon={faExternalLinkAlt} /> */}
			{/*<MainMenuItem text="Organizations" link="organizations" icon="office" />
			<MainMenuItem text="Contacts" link="contacts" icon="users" />
			<MainMenuItem text="Reports" link="reports" icon="printer" />*/}
			{auth.user.is_admin && <AccordionMenu title="Configuraciones" icon={faCogs}>
				<MainMenuItem text="Cotizadores" link="config.cotizadores" icon={faCog} />
			</AccordionMenu>}
		</div>
	);
};
